import React from 'react';
import SmallTag from './SmallTag'; // ton composant actuel, inchangé

// comparateur: rerender seulement si ce qui influence l'affichage change
function arePropsEqual(prev, next) {
  // le plus important: la valeur et l'identité du champ
  if (prev.field?.attrName !== next.field?.attrName) return false;
  if (prev.field?.value !== next.field?.value) return false;

  // zones / apparence
  if (prev.zoneType !== next.zoneType) return false;
  if (prev.nodeColor !== next.nodeColor) return false;

  // clés d'itération et cible
  if (prev.ind !== next.ind) return false;
  if (prev.objId !== next.objId) return false;

  // si ces objets changent souvent de *référence* mais pas de contenu,
  // on peut ignorer leurs changements pour éviter des rerenders:
  // (décommente si besoin)
  // if (prev.dicoNameRef !== next.dicoNameRef) return true;
  // if (prev.objectsDefList !== next.objectsDefList) return true;
  // if (prev.pal !== next.pal) return true;

  return true; // pas de changement significatif -> on saute le render
}

const SmallTagMemo = React.memo(SmallTag, arePropsEqual);
SmallTagMemo.displayName = 'SmallTagMemo';

export default SmallTagMemo;
